import React from 'react';
import { useSelector } from 'react-redux';

import Iframe from '@swf/components/Iframe/Iframe';
import Body from '@swf/components/StarsModal/components/Body';
import CloseButton from '@swf/components/StarsModal/components/CloseButton';
import Header from '@swf/components/StarsModal/components/Header/Header';
import Translation from '@swf/components/Translation/Translation';
import { ResolverTag, TokenType } from '@swf/core/enums';
import useResolver from '@swf/core/hooks/useResolver';
import { select } from '@swf/core/store';

import { TXTCLI_Contact_Support } from './StarsHelp.messages.json';
import styles from './StarsHelp.scss';

const StarsHelp: React.FC = () => {
  const isAuthenticated = useSelector(select.session.isAuthenticated);

  const contactSupportURL = useResolver(ResolverTag.ContactSupport, {
    tokenType: isAuthenticated ? TokenType.CustomerSupport : TokenType.Invalid
  });

  return (
    <>
      <Header>
        <Translation {...TXTCLI_Contact_Support} />
        <CloseButton />
      </Header>
      <Body>
        <Iframe src={contactSupportURL} className={styles.contactSupportForm} scrolling="yes" />
      </Body>
    </>
  );
};

export default StarsHelp;
